export default __webpack_public_path__ + "static/media/acm_cta_register_banner.d6a484d2.png";